"use client";

import { DefaultNotificationToastItem } from "./default";
import { MentionNotificationToastItem } from "./mentions";
import { ReplyNotificationToastItem } from "./replies";
import type { NotificationToastItemProps } from "./layout";

export function NotificationToastItem(props: NotificationToastItemProps) {
  switch (props.notification.category) {
    case "mentions":
      return <MentionNotificationToastItem {...props} />;
    case "replies":
    case "sequence_replies":
      return <ReplyNotificationToastItem {...props} />;
    default:
      return <DefaultNotificationToastItem {...props} />;
  }
}

export { NotificationToastItemLayout } from "./layout";
